module.exports = __webpack_public_path__ + "media/images/objects/OLD/object-5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/objects/OLD/object-5.jpg
// module id = 90
// module chunks = 0